import * as CountryRegionDataImport from "react-country-region-selector";

/**
 * Extracts all US states from the CountryRegionData
 * @returns Array of US state names (e.g., ["Alabama", "Alaska", "Arizona", ...])
 */
export const getUSStates = (): string[] => {
  const CountryRegionData = CountryRegionDataImport.CountryRegionData;
  const data = CountryRegionData.default;

  const usEntry = data.find(
    (entry) => entry[1] === "US" || entry[0] === "United States",
  );

  if (!usEntry) {
    console.error("US entry not found in CountryRegionData");
    return [];
  }

  const regionsString = usEntry[2];

  if (!regionsString) {
    return [];
  }

  const states = regionsString
    .split("|")
    .map((region) => region.split("~")[0])
    .filter(Boolean);

  return states;
};

export const US_STATES = getUSStates();
